import React from 'react';

const Allergens: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Allergen Information</h1>
      <p className="text-gray-700 mb-6">We prepare food and drinks in a kitchen that handles all 14 major allergens.</p>

      <p className="mb-4">Please inform us of any allergies. We will do our best to accommodate, but we cannot guarantee the absence of allergen cross-contamination.</p>
    </div>
  );
};

export default Allergens;





